/**
 * The star on a lesson — docs/06-UI-SPEC.md §11.1, SRS I5.
 *
 * The same control in both views, so starring means the same thing wherever a teacher
 * happens to be looking. It stops the click from reaching the row underneath: starring
 * a lesson is not opening it.
 */

export interface StarButtonProps {
  readonly starred: boolean;
  readonly onToggle: () => void;
}

export function StarButton({ starred, onToggle }: StarButtonProps) {
  return (
    <button
      type="button"
      aria-pressed={starred}
      aria-label={starred ? 'Remove the star' : 'Star this lesson'}
      onClick={(event) => {
        event.stopPropagation();
        onToggle();
      }}
      className={`h-touch w-touch rounded-md text-lg transition-colors duration-fast hover:bg-surface-hover ${
        starred ? 'text-warning' : 'text-text-placeholder'
      }`}
    >
      {starred ? '★' : '☆'}
    </button>
  );
}
